<template>
  <div class="bg-grey-lines block-fullscreen">
    <div class="header-logo">
      <icon name="td-logo" color="#393f49" />
    </div>
    <section class="block-fullscreen-center block-step block-fullscreen-text">
      <h1 class="title-section">Estratégia</h1>
      <div class="title-main">
        <p>Mindset, cultura e processos digitais precisam de um ecossistema que permita sua existência. No entanto, para alcançá-lo, é necessário criar um estratégia que suporte as mudanças e vá de encontro às metas da empresa.<p>
        <p>Como anda a estratégia digital da sua empresa?</p>
      </div>
      <router-link :to="nextScreen" class="nav-arrow-down">
        <div class="title hidden-sm">
          Role para baixo
        </div>
        <icon name="arrow-line-right" class="arrow-right animation-blink" />
      </router-link>
    </section>
  </div>
</template>

<script>
import Icon from './Icon';
import rollDown from './mixins/rollDown';

/* eslint-disable max-len */
export default {
  name: 'strategy',
  mixins: [rollDown],
  components: { Icon },
  data() {
    return {
      nextScreen: '/estrategia/formulario',
    };
  },
  mounted() {
    this.$store.commit('SET_BAR_PROGRESS', 5);
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Strategy.vue